import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";

export default function RemoveBaladiyaPopUp({
  open,
  setOpen,
  list,
  updateData
}) {
  console.log("log data.....",list)

  const token = localStorage.getItem("nodeToken");

  const dispatch = useDispatch();

  const handleSubmitClick = async () => {
    try {
      const mappedData = list.map((data) => data.employee_id);
      const response = await nodeinstance.put(`/baladiya/RemoveData`, mappedData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        updateData();
        setOpen(false);
        // setApiKey("")
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center flex`}
      >
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold">
              {" "}
              Update employee Status
            </h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setOpen(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="flex  gap-3 mx-auto my-3 w-full px-5">
            <button
              className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              onClick={() => {
                handleSubmitClick();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
